import React, { forwardRef, useContext, useEffect, useImperativeHandle, useState } from "react";
import './SliderActivity.scss';
import useSlider from "../../../shared/components/Slider/useSlider";
import { Button, Checkbox, Column, DateTimePicker, Label, Row, Select } from "../../../components";
import { SelectOption } from "../../../shared/components/input";
import CustomerActivityService from "../../customer-activity/CustomerActivityService";
import Logger from "../../../shared/services/Logger";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/store";
import { updateLookupData } from "../../customer-slice/Customer-lookup-slice";
import { CustomerScreenTabs, CustomerTaskConstants, CUSTOMER_NOT_FOUND, SlicerLookUpConstant, SliderActivityConstant } from "../../../shared/util/constant";
import * as  lables from "../../../shared/util/label";
import { useConfirmationModalContext } from "../../../shared/components/ModalConfirmationContext";
import SliderActivityService from "./SliderActivityService";
import { AppEvenType, notifyAppEvent } from "../../../shared/store/component-notification/ComponentNotification";
import { cleareTabsInputs, setDefaultActivityData, setDefaultTaskData, SliderDataAction, updateSliderCurrentTab, updateSliderData } from "../CustomerSliderContext";
import CustomerDetailService from "../../customer-details/CustomerDetailService";
import { updateCustomers } from "../../customer-slice/Customer-slice";
import CustomerSliderContainerService from "../CustomerSliderContainerService";
import { AbilityContext } from "../../../shared/abilities/AbilityContext";
import * as constant from '../../../shared/util/constant';
import { FloatingLabel, Form } from "react-bootstrap";

import { TaskScreenLables } from "../../../shared/util/label";
import CustomerTaskViewService from '../../customer-tasks/CustomerTasksViewService';
import { CustomerTaskDto } from '../../model/CustomerTaskDto';
import { LookupDetailConstants } from "../../../shared/util/LookupDetailConstants";
import SliderTaskService from "../slider-task/SliderTaskService";
import { CommonUtility } from "../../../Services/CommonUtility";

export interface ISliderActivity {
    customerId?: string
    navigateTo: (path: string) => void
}

// methods exposed to parent
export interface SliderActivityHandles {
    save: () => Promise<boolean>;
}

const SliderActivityInner: React.ForwardRefRenderFunction<SliderActivityHandles, ISliderActivity> = (props, ref) => {
    const dispatch = useDispatch();
    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    let customerSliderState = useSelector((state: RootState) => state?.CustomerSliderState);
    const slider = useSlider();
    const modalContext = useConfirmationModalContext();
    const customerActivityService = new CustomerActivityService();
    const customerDetailService = new CustomerDetailService();
    const sliderActivityService = new SliderActivityService();
    const customerSliderContainerService = new CustomerSliderContainerService();

    const activityTypeList = useSelector((state: RootState) => state?.LookupState.activityTypeList);

    const [activityTypes, setActivityTypes] = useState<SelectOption[]>([]);
    const [customerOptions, setCustomerOptions] = useState<SelectOption[]>([]);
    const [activitiyCustId, setActivitiyCustId] = useState<string>(null);

    /// These two data are dynamic and dont have dedicated store, hence storing as part of activity page info.
    const activityData = customerSliderState.activityPage.activity;
    const taskData = customerSliderState.taskPage.customerTask;
    const formValidationForActivityPage = customerSliderState.activityPage.formValidation;
    const policiesForSelect = [...customerSliderState.activityPage.policiesForSelect];

    const ability = useContext(AbilityContext);
    const canUserCreateCustomerActivity = ability.can('create', 'Customer Activity', constant.ScreenName.CUSTOMER_ACTIVITY);


    //Customer Task data
    const customerTaskService = new CustomerTaskViewService();
    const customerTask = customerSliderState.taskPage.customerTask;
    const formValidationForTask = customerSliderState.taskPage.formValidation;
    const sliderTaskService = new SliderTaskService();

    const [checked, setChecked] = useState(false);

    const userDetails = useSelector((state: any) => state.userContextSlice);
    const taskPriorities = useSelector((state: RootState) => state?.LookupState.taskPriorityList);
    const taskTypes = useSelector((state: RootState) => state?.LookupState.activityTypeList);
    const taskStatuses = useSelector((state: RootState) => state?.LookupState.taskStatusList);
    const empList = useSelector((state: RootState) => state?.LookupState.employeeList);
    const companyList = useSelector((state: RootState) => state?.LookupState.companyList);

    const [taskPriorityList, setTaskPriorityList] = useState<SelectOption[]>([]);
    const [taskStatusList, setTaskStatusList] = useState<SelectOption[]>([]);
    const [taskTypeList, setTaskTypeList] = useState<SelectOption[]>([]);
    const [employeeList, setEmployeeList] = useState<SelectOption[]>([]);
    const [companiesList, setCompanyList] = useState<SelectOption[]>([]);
     const [isPolicyOptional, setIsPolicyOptional] = useState(false);
    const hasPolicyOptions = (policiesForSelect?.length ?? 0) > 0;

    useEffect(() => {
        initializeComponent();
    }, []);


    const initializeComponent = async () => {
        try {

            // Fetch and configure activity types
            if (!activityTypeList || activityTypeList.length == 0) {
                let actTypeData = await customerActivityService.getActivityTypes();
                setActivityTypes(actTypeData);
                dispatch(updateLookupData({ data: actTypeData, type: SlicerLookUpConstant.ACTIVITY_TYPE }));
            }
            else {
                setActivityTypes([...activityTypeList]);
            }
            
            if (!policiesForSelect || policiesForSelect.length == 0) {
                var custPolicyData = await customerActivityService.getPoliciesForCustomer(props.customerId);
                dispatch(updateSliderData({ type: SliderDataAction.ActivityPolicyListUpdate, data: custPolicyData }));
            }

            // Fetch and configure customer options
            let custOptions: SelectOption[] = [];
            let cstId = null;
            if (customerInfo?.customer?.id) {
                let displayName = customerInfo?.customer?.firstName + (customerInfo?.customer?.lastName ? ' ' + customerInfo?.customer?.lastName : '');
                custOptions = [
                    {
                        label: displayName,
                        value: customerInfo?.customer?.id
                    }
                ];

                cstId = customerInfo?.customer?.id;
            }
            else {
                let cst = await customerDetailService.fetchCustomerById(props.customerId);
                if (cst) {
                    let displayName = cst?.firstName + (cst?.lastName ? ' ' + cst?.lastName : '');
                    custOptions = [
                        {
                            label: displayName,
                            value: cst.id
                        }
                    ];

                    cstId = cst.id;

                    dispatch(updateCustomers(cst));
                }
            }

            setCustomerOptions(custOptions);
            setActivitiyCustId(cstId);
        let currDateTime= new Date();
        
        dispatch(updateSliderData({ type: SliderDataAction.ActivityUpdate, data: {policyId:(custPolicyData?.length === 1 ? custPolicyData[0]?.value : null), activityEffDate:currDateTime}}));
        dispatch(setDefaultActivityData({activityEffDate:currDateTime,policyId:(custPolicyData?.length ===1 ? custPolicyData[0]?.value : null)}));
        }
        catch (ex) {
            // toast.error(SliderActivityConstant.ERROR_WHILE_LOADING_ACTIVITY_PAGE);
            Logger.logError(SliderActivityConstant.ERROR_WHILE_LOADING_ACTIVITY_PAGE);
        }
    }

    const initializeTaskComponent = async () => {
        let tskStatusList = [];
        let tskPriorityList = [];
        let tskTaskTypeList = [];
        let emplSelectList = [];
        let compSelectList = [];

        if (!taskPriorities || taskPriorities.length == 0) {
            tskPriorityList = await customerTaskService.getTaskPriorityList();
            dispatch(updateLookupData({ data: tskPriorityList, type: SlicerLookUpConstant.TASK_PRIORITY }));
        }
        else {
            tskPriorityList = [...taskPriorities];
        }

        if (!taskTypes || taskTypes.length == 0) {
            tskTaskTypeList = await customerTaskService.getTaskTypeList();
            dispatch(updateLookupData({ data: tskTaskTypeList, type: SlicerLookUpConstant.ACTIVITY_TYPE }));
        }
        else {
            tskTaskTypeList = [...taskTypes];
        }

        if (!taskStatuses || taskStatuses.length == 0) {
            tskStatusList = await customerTaskService.getTaskStatusList();
            dispatch(updateLookupData({ data: tskStatusList, type: SlicerLookUpConstant.TASK_STATUS }));
        }
        else {
            tskStatusList = [...taskStatuses];
        }

        if (!empList || empList.length == 0) {
            emplSelectList = await customerTaskService.getEmployeeList();
            dispatch(updateLookupData({ data: emplSelectList, type: SlicerLookUpConstant.EMPLOYEE_LIST }));
        }
        else {
            emplSelectList = [...empList];
        }

        if (!companyList || companyList.length == 0) {
            compSelectList = await customerTaskService.getCompanyList();
            dispatch(updateLookupData({ data: compSelectList, type: SlicerLookUpConstant.COMPANY_LIST }));
        }
        else {
            compSelectList = [...companyList];
        }

        setTaskPriorityList(tskPriorityList);
        setTaskStatusList(tskStatusList);
        setTaskTypeList(tskTaskTypeList);
        setEmployeeList(emplSelectList);
        setCompanyList(compSelectList);


        if (!policiesForSelect || policiesForSelect.length == 0) {
            let custPolicyData = await customerActivityService.getPoliciesForCustomer(customerInfo?.customer?.id);
            // if (!custPolicyData || custPolicyData.length == 0) {
            //     setIsPolicyOptional(true);
            // }
            // else {
            //     setIsPolicyOptional(false);
            // }

            // Always initialize the customerTask fields when opening the slider
            // Find the default policy and its associated company
            const defaultPolicy = custPolicyData.length === 1 ? custPolicyData[0] : null;
            const defaultCompanyId = defaultPolicy?.companyId || null;

            let updatedTaskData = {
                ...customerTask,
                custId: customerInfo?.customer?.id,
                dueDate: customerTask.dueDate || new Date(),
                polId: customerTask.polId || (defaultPolicy ? defaultPolicy.value : null),
                companyId: customerTask.companyId || defaultCompanyId, // Set the default companyId
                toUserId: customerTask.toUserId || userDetails?.userContext?.id, // Set assignedTo as current logged-in user
                priorityId: customerTask.priorityId || LookupDetailConstants.CUSTOMER_TASK_PRIORITY.LOW, // Set priority as "Low"
                statusId: customerTask.statusId || LookupDetailConstants.CUSTOMER_TASK_STATUS.INCOMPLETE, // Set status as "Incomplete"
            };
            saveTaskInStore(updatedTaskData);

            dispatch(updateSliderData({ type: SliderDataAction.TaskPolicyListUpdate, data: custPolicyData }));
        } else {
            // Find the default policy and its associated company
            const defaultPolicy = policiesForSelect.length === 1 ? policiesForSelect[0] : null;
            const defaultCompanyId = defaultPolicy?.companyId || null;
            let updatedTaskData = {
                ...customerTask,
                custId: customerTask.custId || customerInfo?.customer?.id,
                dueDate: customerTask.dueDate || new Date(),
                polId: customerTask.polId || (defaultPolicy ? defaultPolicy.value : null),
                companyId: customerTask.companyId || defaultCompanyId, // Set the default companyId
                toUserId: customerTask.toUserId || userDetails?.userContext?.id, // Set assignedTo as current logged-in user
                priorityId: customerTask.priorityId || LookupDetailConstants.CUSTOMER_TASK_PRIORITY.LOW, // Set priority as "Low"
                statusId: customerTask.statusId || LookupDetailConstants.CUSTOMER_TASK_STATUS.INCOMPLETE, // Set status as "Incomplete"
            };
            // Only update if any field is missing
            if (!customerTask.custId || !customerTask.dueDate || !customerTask.polId) {
                saveTaskInStore(updatedTaskData);
            }
        }
    }

    useEffect(() => {
        if (checked) {
            // Data related to Task Screen
            initializeTaskComponent();
        }
    },[checked]);

    const handleDescriptionChange = (event) => {
        const value = event.currentTarget.value;
        onEntityFieldChangeForActivity('description', value);
        setTimeout(() => {
            const textarea = event.target;
            textarea.scrollTop = textarea.scrollHeight;
        }, 0);
    };

    // Only normalize on paste
    const handleDescriptionPaste = (event) => {
        event.preventDefault();
        let paste = (event.clipboardData || window.Clipboard).getData('text');
        paste = CommonUtility.normalizeEmailText(paste);
        // Insert at cursor position
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const currentValue = textarea.value;
        const newValue = currentValue.slice(0, start) + paste + currentValue.slice(end);
        onEntityFieldChangeForActivity('description', newValue);
        setTimeout(() => {
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = start + paste.length;
        }, 0);
    };


    const saveTaskInStore = (customerTask: CustomerTaskDto) => {
        dispatch(updateSliderData({ type: SliderDataAction.TaskUpdate, data: customerTask }));
         dispatch(setDefaultTaskData(customerTask));
    }
    const onEntityFieldChangeForActivity = (propName: string, value: string | Date | boolean) => {
        let updatedActivityData = {
            ...activityData,
            [propName]: value,
        };

        if (propName == "activityTypeId") {
            const updatedTaskData = {
                ...customerTask,
                taskTypeId: value?.toString(),
            };
            dispatch(updateSliderData({ type: SliderDataAction.TaskUpdate, data: updatedTaskData }));
        }
        else if (propName == "policyId") {
            // Update polId in customerTask and dispatch to store
            const updatedTaskData = {
                ...customerTask,
                polId: value?.toString(),
            };
            dispatch(updateSliderData({ type: SliderDataAction.TaskUpdate, data: updatedTaskData }));
        }
        dispatch(updateSliderData({ type: SliderDataAction.ActivityUpdate, data: updatedActivityData }));
    }

    const onEntityFieldChangeForTask = (propName: string, value: string | Date | boolean) => {
        let updatedTaskData = {
            ...taskData,
            [propName]: value,
        };
        dispatch(updateSliderData({ type: SliderDataAction.TaskUpdate, data: updatedTaskData }));
    }

    let lableSize = 4;
    let inputSize = 8;
    const isEditable = true;

  const onCancelClick = async () => {
    const defaultPolicyId = policiesForSelect?.length === 1 ? policiesForSelect[0]?.value : null;
    dispatch(updateSliderData({ type: SliderDataAction.ActivityUpdate, data: { activityEffDate: new Date(), description: "",claimId:"",policyId: defaultPolicyId}}));
    dispatch(setDefaultActivityData({ activityEffDate: new Date(), policyId: defaultPolicyId }));
    if(checked){
     dispatch(updateSliderData({ type : SliderDataAction.TaskUpdate, data : {...customerTask,description : '',claimId : '',ccUserId : '', taskTypeId : ''}}));
     setChecked(false)
}

  }

  
// Expose save() to parent via ref
    useImperativeHandle(ref, () => ({
        save: async () => {
            return await onSaveClick();
        }
    }), [activityData, customerInfo, checked, customerTask]);
    
    const onSaveClick = async () => {        
        try {
            let validationError = sliderActivityService.validateActivity(activityData);
            if (hasPolicyOptions && (!activityData.policyId || String(activityData.policyId).trim().length === 0)) {
                validationError['policyId'] = { isValid: false, warningText: constant.FIELD_BLANK };
            }
            dispatch(updateSliderData({ type: SliderDataAction.ActivityFormValidationUpdate, data: validationError }));
            if (Object.keys(validationError).length > 0) {
                toast.warn(SliderActivityConstant.FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return false;
            }
            let validateTaskError;
            if (checked) {
                validateTaskError = sliderTaskService.validateSliderTask(customerTask, !hasPolicyOptions);
                dispatch(updateSliderData({ type: SliderDataAction.TaskFormValidationUpdate, data: validateTaskError }));

                if (Object.keys(validateTaskError).length > 0) {
                    toast.warn(CustomerTaskConstants.FORM_VALIDATION_ERROR_MESSAGE, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    return false;
                }
            }
            if (Object.keys(validationError).length > 0 || (checked && Object.keys(validateTaskError).length > 0)) { return false; }
            let requestDto = sliderActivityService.getActivityRequest(activityData, props.customerId);
            let activityCreated = await customerActivityService.addNewActivity(requestDto);
            toast.success(SliderActivityConstant.ACTIVITY_SAVED_SUCCESSFULLY);
            dispatch(notifyAppEvent({ eventType: AppEvenType.NewCustomerActivityCreated, eventData: activityCreated }));
            dispatch(cleareTabsInputs());
            dispatch(updateSliderCurrentTab(constant.CustomerScreenTabs.activity.key));
            if (checked) {
                await onTaskSave();                
            } 
            const defaultPolicyId = policiesForSelect?.length === 1 ? policiesForSelect[0]?.value : null;
            dispatch(updateSliderData({ type: SliderDataAction.ActivityUpdate, data: { activityEffDate: new Date(), description: "", claimId: "", policyId: defaultPolicyId }}));
            dispatch(setDefaultActivityData({ activityEffDate: new Date(), policyId: defaultPolicyId}));
             
            return true;
        }
        catch (ex) {
            if ((ex.status == 422 && ex.data?.error == constant.CustomerTaskConstants.CUSTOMER_DELETED) || ex.status == 404) {
                toast.error(constant.CUSTOMER_NOT_FOUND);
                props.navigateTo('/customer/customerfilter');
            }
            toast.error(SliderActivityConstant.ERROR_WHILE_SAVING_ACTIVITY);
            Logger.logError(SliderActivityConstant.ERROR_WHILE_SAVING_ACTIVITY, ex);
            return false;
        }
    }

    const onTaskSave = async () => {
        try {

            let validationError = sliderTaskService.validateSliderTask(customerTask, !hasPolicyOptions);
            dispatch(updateSliderData({ type: SliderDataAction.TaskFormValidationUpdate, data: validationError }));

            if (Object.keys(validationError).length > 0) {
                toast.warn(CustomerTaskConstants.FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }

            let taskPolicy = policiesForSelect?.find(item => item.value == customerTask.polId);
            let taskRequestDto = sliderTaskService.getTaskRequestDto(customerTask, taskPolicy?.originalData?.polEffDate);

            let newTask = await sliderTaskService.createTask(taskRequestDto);
            toast.success(CustomerTaskConstants.TASK_SAVED_SUCCESSFULLY);
            dispatch(notifyAppEvent({ eventType: AppEvenType.NewTaskCreated, eventData: newTask }));
            dispatch(cleareTabsInputs());
            //dispatch(updateSliderCurrentTab(CustomerScreenTabs.tasks.key));
            const defaultPolicy = policiesForSelect.length === 1 ? policiesForSelect[0] : null;
            const defaultCompanyId = defaultPolicy?.companyId || null;
            saveTaskInStore({
                dueDate: new Date(), custId: customerInfo?.customer?.id,
                polId: (defaultPolicy ? defaultPolicy.value : null),
                companyId: defaultCompanyId, // Set the default companyId
                toUserId: customerTask.toUserId || userDetails?.userContext?.id, // Set assignedTo as current logged-in user
                priorityId: customerTask.priorityId || LookupDetailConstants.CUSTOMER_TASK_PRIORITY.LOW, // Set priority as "Low"
                statusId: customerTask.statusId || LookupDetailConstants.CUSTOMER_TASK_STATUS.INCOMPLETE, // Set status as "Incomplete"
                description: '',
                claimId: '',
            });
        }
        catch (ex) {
            if ((ex.status == 422 && ex.data?.error == CustomerTaskConstants.CUSTOMER_DELETED) || ex.status == 404) {
                toast.error(CUSTOMER_NOT_FOUND);
                props.navigateTo('/customer/customerfilter');
                return;
            }
            toast.error(CustomerTaskConstants.ERROR_WHILE_INITIALIZING_TASK_SLIDER_COMPONENT);
            Logger.logError(CustomerTaskConstants.ERROR_WHILE_INITIALIZING_TASK_SLIDER_COMPONENT, ex);
        }
    }

    useEffect(() => {
        if (policiesForSelect && policiesForSelect.length === 1 &&
            (!activityData.policyId || !policiesForSelect.some(p => p.value === activityData.policyId))) {
            let updatedActivityData = {
                ...activityData,
                ['policyId']: policiesForSelect[0].value,
            };
            let updateTaskData = {
                ...customerTask,
                ['polId']: policiesForSelect[0].value,
            };
            dispatch(updateSliderData({ type: SliderDataAction.ActivityUpdate, data: updatedActivityData }));
            dispatch(updateSliderData({ type: SliderDataAction.TaskUpdate, data: updateTaskData }));
        }
    }, [policiesForSelect, activityData.policyId, customerTask]);

    const mainContennt = <>
        <Row>
            <Column lg={12} md={12} className="">
                <h6 className="sld-act-section-header">{lables.CustomerActivityLabel.NEW_ACTIVITY}</h6>
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12}>
                <Select
                    id='action'
                    label={lables.CustomerActivityLabel.ACTIVITY_TYPE}
                    options={activityTypes}
                    defaultSelected={activityTypes?.filter(({ value }) =>
                        value === activityData.activityTypeId
                    )}
                    onChange={(values) => {
                        onEntityFieldChangeForActivity('activityTypeId', values[0] as string)
                    }}
                    isRequired={true}
                    placeholder={lables.CustomerActivityLabel.PLEASE_SELECT}
                    multiple={false}
                    isInvalid={formValidationForActivityPage['activityTypeId']?.isValid == false}
                    invalidWarning={formValidationForActivityPage['activityTypeId']?.warningText}
                    invalidLableClass="lable-error sld-act-input-error"
                    tabIndex={1001}
                    showAsFloatingLabel={true}
                    className='mb-3'
                />
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12}>
                <FloatingLabel
                    controlId="activityDescription"
                    label={
                        <>
                            {lables.CustomerActivityLabel.DESCRIPTION}
                            <span className="text-danger">*</span>
                        </>
                    }
                >
                    <Form.Control
                        as="textarea"
                        name="activityDescription"
                        placeholder={lables.CustomerActivityLabel.DESCRIPTION}
                        value={activityData.description}
                        onChange={handleDescriptionChange}
                        onPaste={handleDescriptionPaste}
                        disabled={!isEditable}
                        tabIndex={1003}
                        // maxLength={765}
                        isInvalid={formValidationForActivityPage['description']?.isValid == false}
                        className='texbox-input sld-act-descr-input mb-3'
                    />
                    {formValidationForActivityPage['description']?.isValid == false && (
                        <Form.Control.Feedback type="invalid">
                            {formValidationForActivityPage['description']?.warningText}
                        </Form.Control.Feedback>
                    )}
                </FloatingLabel>
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12}>
                <Row>
                    <Column lg={3} md={lableSize} className="">
                        <Label text={lables.CustomerActivityLabel.ACTIVITY_EFFECTIVE_DATE} className="inlineLable sld-inlineLable sld-inlineLable" />
                    </Column>
                    <Column lg={4} md={4} className="">
                        <DateTimePicker
                            dateFormatCalendar="LLLL yyyy"
                            dropdownMode="scroll"
                            selected={activityData.activityEffDate}
                            maxDate={new Date()}
                            tabIndex={1008}
                            onChange={(date) => onEntityFieldChangeForActivity('activityEffDate', date)} />
                    </Column>
                    {/* </Row>
          <Row style={{marginTop: "15px"}}> */}
                    <Column lg={1} md={1}>
                        <span className="d-block mt-1">At</span>
                    </Column>
                    <Column lg={4} md={3} className="">
                        <DateTimePicker
                            selected={activityData.activityEffDate}
                            tabIndex={1009}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            maxDate={new Date()}
                            minTime={new Date(1990, 0, 1)}
                            maxTime={new Date()}
                            dateFormat="h:mm aa"
                            timeCaption="Time"
                            placeholderText="hh:mm"
                            //className="sld-act-time-picker"
                            isInvalid={formValidationForActivityPage['activityEffDate']?.isValid == false}
                            invalidWarning={formValidationForActivityPage['activityEffDate']?.warningText}
                            invalidLableClass="lable-error sld-act-input-error"
                            onChange={(date) => onEntityFieldChangeForActivity('activityEffDate', date)} />
                    </Column>
                </Row>
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12} className="">
                <h6 className="sld-act-section-header mt-3">{lables.CustomerActivityLabel.CUSTOMER_POLICY_INFORMATION}</h6>

            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12}>
                <Select
                    id='customerSelect'
                    label={lables.CustomerActivityLabel.CUSTOMER_SELECT}
                    options={customerOptions}
                    defaultSelected={customerOptions?.filter(({ value }) =>
                        value == activitiyCustId
                    )}
                    onChange={(values) => {
                        onEntityFieldChangeForActivity('activitiyCustId', values[0] as string)
                    }}
                    placeholder={lables.CustomerActivityLabel.PLEASE_SELECT}
                    multiple={false}
                    tabIndex={1010}
                    showAsFloatingLabel={true}
                    className='mb-3'
                />
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12}>
                <Select
                    key={`${String(activityData.policyId ?? '')}_${String(policiesForSelect?.length ?? 0)}`}
                    id='policySelect'
                    label={lables.CustomerActivityLabel.POLICY_SELECT}
                    options={policiesForSelect}
                    defaultSelected={policiesForSelect?.filter(({ value }) =>
                        value === activityData.policyId
                    )}
                    onChange={(values) => {
                        onEntityFieldChangeForActivity('policyId', values[0] as string)
                    }}
                    placeholder={lables.CustomerActivityLabel.PLEASE_SELECT}
                    multiple={false}
                    tabIndex={1012}
                    sortOptions={false}
                    showAsFloatingLabel={true}
                    className='mb-3'
                    isRequired={hasPolicyOptions}
                    isInvalid={hasPolicyOptions && formValidationForActivityPage['policyId']?.isValid == false}
                    invalidWarning={hasPolicyOptions && formValidationForActivityPage['policyId']?.isValid == false ? constant.FIELD_BLANK : ''}
                />
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12}>
                <FloatingLabel
                    controlId="claimNumber"
                    label={lables.CustomerActivityLabel.CLAIM_SELECT}
                >
                    <Form.Control
                        type="text"
                        name="claimNumber"
                        placeholder={lables.CustomerActivityLabel.CLAIM_SELECT}
                        value={activityData.claimId}
                        onChange={(event) => onEntityFieldChangeForActivity('claimId', event.currentTarget.value)}
                        disabled={!isEditable}
                        tabIndex={1013}
                        maxLength={60}
                        className='texbox-input'
                    />
                </FloatingLabel>
            </Column>
        </Row>

        <Row style={{ marginTop: "10px" }}>
            <Column>
                <Row style={{ marginTop: "10px" }}>
                    <Column>
                        <div className="d-flex align-items-center">
                            <div className="d-flex" style={{ gap: '16px', width: '100%' }}>
                                <Checkbox
                                    id='createTaskCheckbox'
                                    label={TaskScreenLables.CREATE_TASK}
                                    checked={checked}
                                    onChange={(e) => setChecked(e.target.checked)}
                                    tabIndex='1014'
                                    className="create-task-switch"
                                    labelClassName="fw-bold"
                                />
                            </div>
                        </div>
                    </Column>
                </Row>

            </Column>
        </Row>
        <Row style={{ marginBottom: "10px" }}>
            <Column>

            </Column>
        </Row>
        <Row>
            <Column>
                {checked &&
                    <>
                        <Row>
                        <Column lg={12} md={12}>
                            <FloatingLabel
                                controlId="taskDescription"
                                label={<>
                                    {TaskScreenLables.description}
                                    <span className="text-danger">*</span>
                                </>}>
                                <Form.Control
                                    as="textarea"
                                    name="taskDescription"
                                    placeholder={TaskScreenLables.description}
                                    value={customerTask.description}
                                onChange={(event) => onEntityFieldChangeForTask('description', event.currentTarget.value)}
                                    disabled={!isEditable}
                                    tabIndex={1015}
                                    maxLength={1000}
                                    isInvalid={formValidationForTask['description']?.isValid == false}
                                    className='texbox-input sld-task-descr-input mb-3' />
                                {formValidationForTask['description']?.isValid == false && (
                                    <Form.Control.Feedback type="invalid">
                                        {formValidationForTask['description']?.warningText}
                                    </Form.Control.Feedback>
                                )}
                            </FloatingLabel>
                        </Column>
                </Row>
                    <Row>
                            <Column lg={12} md={12}>
                                <Select
                                    id='ddToUserId'
                                    label={TaskScreenLables.assignedTo}
                                    options={employeeList ?? []}
                                    defaultSelected={employeeList?.filter(({ value }) => String(value) === String(customerTask.toUserId)
                                    ) ?? []}
                                    onChange={(values) => {
                                        const selectedValue = values?.[0];
                                        if (selectedValue) {
                                            onEntityFieldChangeForTask('toUserId', selectedValue as string);
                                        }
                                    }}
                                    isRequired={true}
                                    placeholder={TaskScreenLables.pleaseSelect}
                                    multiple={false}
                                    isInvalid={formValidationForTask['toUserId']?.isValid == false}
                                    invalidWarning={formValidationForTask['toUserId']?.warningText}
                                    tabIndex={1016}
                                    showAsFloatingLabel={true}
                                    className='mb-3' />
                            </Column>
                    </Row>
                    <Row>
                        <Column lg={12} md={12}>


                            <DateTimePicker
                                dateFormatCalendar="LLLL yyyy"
                                dropdownMode="scroll"
                                className='mb-3'
                                selected={customerTask.dueDate}
                                tabIndex={1017}
                                isRequired={true}
                                prependLabelText={TaskScreenLables.dueDate}
                                showAppendIcon={true}
                                onChange={(date) => onEntityFieldChangeForTask('dueDate', date)}
                                isInvalid={formValidationForTask['dueDate']?.isValid == false}
                                invalidWarning={formValidationForTask['dueDate']?.warningText}
                                invalidLableClass="lable-error sld-task-input-error"
                                errorLableDivClassName='sld-task-action-select-div' />

                            {formValidationForTask['dueDate']?.isValid === false && (
                                <Form.Control.Feedback type="invalid">
                                    {formValidationForTask['dueDate']?.warningText}
                                </Form.Control.Feedback>
                            )}


                        </Column>
                    </Row>
                    <Row>
                        <Column lg={12} md={12}>
                            <Select
                                id='ddTaskPriority'
                                label={TaskScreenLables.priority}
                                options={taskPriorityList}
                                defaultSelected={taskPriorityList?.filter(({ value }) =>
                                    String(value) === String(customerTask.priorityId)
                                ) ?? []}
                                onChange={(values) => {
                                    onEntityFieldChangeForTask('priorityId', values[0] as string)
                                }}
                                isRequired={true}
                                placeholder={TaskScreenLables.pleaseSelect}
                                multiple={false}
                                isInvalid={formValidationForTask['priorityId']?.isValid == false}
                                invalidWarning={formValidationForTask['priorityId']?.warningText}
                                tabIndex={1018}
                                showAsFloatingLabel={true}
                                className='mb-3'
                            />
                        </Column>
                    </Row>
                    <Row>
                        <Column lg={12} md={12}>
                            <Select
                                id='ddTaskStatus'
                                label={TaskScreenLables.status}
                                options={taskStatusList}
                                defaultSelected={taskStatusList?.filter(({ value }) =>
                                    String(value) === String(customerTask.statusId)
                                ) ?? []}
                                onChange={(values) => {
                                    onEntityFieldChangeForTask('statusId', values[0] as string)
                                }}
                                isRequired={true}
                                placeholder={TaskScreenLables.pleaseSelect}
                                multiple={false}
                                isInvalid={formValidationForTask['statusId']?.isValid == false}
                                invalidWarning={formValidationForTask['statusId']?.warningText}
                                tabIndex={1019}
                                showAsFloatingLabel={true}
                                className='mb-3'
                            />
                        </Column>
                    </Row>
                    <Row>
                        <Column lg={12} md={12}>
                            <Select
                                id='taskType'
                                label={TaskScreenLables.taskType}
                                options={taskTypeList}
                                defaultSelected={taskTypeList?.filter(({ value }) => value === customerTask.taskTypeId)}
                                onChange={
                                    (values) => {
                                        onEntityFieldChangeForTask('taskTypeId', values[0] as string)
                                    }
                                } isRequired={true}
                                placeholder={TaskScreenLables.pleaseSelect}
                                multiple={false}
                                isInvalid={formValidationForTask['taskTypeId']?.isValid == false}
                                invalidWarning={formValidationForTask['taskTypeId']?.warningText}
                                tabIndex={1020}
                                showAsFloatingLabel={true}
                                className='mb-3'
                                disabled={true }
                            />

                        </Column>
                    </Row>
                    <Row>
                        <Column lg={12} md={12}>
                            <Select
                                id='ddCCUserId'
                                label={TaskScreenLables.cc}
                                options={employeeList ?? []}
                                defaultSelected={employeeList?.filter(({ value }) =>
                                    String(value) === String(customerTask.ccUserId)
                                ) ?? []}
                                onChange={(values) => {
                                    onEntityFieldChangeForTask('ccUserId', values[0] as string)
                                }}
                                isRequired={false}
                                placeholder={TaskScreenLables.pleaseSelect}
                                multiple={false}
                                isInvalid={formValidationForTask['ccUserId']?.isValid == false}
                                invalidWarning={formValidationForTask['ccUserId']?.warningText}
                                tabIndex={1021}
                                showAsFloatingLabel={true}
                                className='mb-3'
                            />
                        </Column>
                    </Row>
                    <Row>
                        <Column lg={12} md={12}>
                            <Select
                                key={customerTask.polId} // This forces re-render when polId changes
                                id='ddSldTaskPolicy'
                                label={TaskScreenLables.policyNumber}
                                options={policiesForSelect }
                                defaultSelected={
                                    policiesForSelect?.filter(({ value }) =>
                                        value === customerTask.polId
                                    )}
                                isRequired={hasPolicyOptions}
                                placeholder={TaskScreenLables.pleaseSelect}
                                multiple={false}
                                showAsFloatingLabel={true}
                                className='mb-3'
                                sortOptions={false}
                                disabled
                            />
                        </Column>
                    </Row>

                    <Row>
                        <Column lg={12} md={12}>
                            <FloatingLabel
                                controlId="ddTskSldClaimNumber"
                                label={TaskScreenLables.claimNumber}
                            >
                                <Form.Control
                                    type="text"
                                    name="ddTskSldClaimNumber"
                                    placeholder={TaskScreenLables.claimNumber}
                                    value={customerTask.claimId}
                                    onChange={(event) => onEntityFieldChangeForTask('claimId', event.currentTarget.value)}
                                    disabled={!isEditable}
                                    tabIndex={1023}
                                    maxLength={60}
                                    className='texbox-input mb-3'
                                />
                            </FloatingLabel>
                        </Column>
                    </Row>

                    <Row>
                        <Column lg={12} md={12}>
                            <Select
                                id='ddlTaskCustomerCompany'
                                label={TaskScreenLables.company}
                                options={companiesList ?? []}
                                defaultSelected={
                                    companiesList?.filter(({ value }) =>
                                        String(value) === String(customerTask.companyId)
                                    ) ?? []
                                }
                                onChange={(values) => {
                                    onEntityFieldChangeForTask('companyId', values[0] as string); // Update the companyId
                                }}
                                isRequired={true}
                                placeholder={TaskScreenLables.pleaseSelect}
                                multiple={false}
                                isInvalid={formValidationForTask['customerCompanyId']?.isValid == false}
                                invalidWarning={formValidationForTask['customerCompanyId']?.warningText}
                                tabIndex={1024}
                                showAsFloatingLabel={true}
                                className='mb-3'
                            />

                        </Column>
                    </Row>
                </>
                }
            </Column>
        </Row>
        {/* Action Row */}
        <Row className="mb-2 sld-margin">
            <Column lg={6} md={6}>
                <Button
                    className='btn btn-outline-tertiary sld-action-btn-base'
                    key="btnActivityCancel"
                    onClick={() => onCancelClick()}
                    id="btnActivityCancel"
                    color='primary'
                    outlined={true}
                    tabIndex={1025}
                >{lables.StandardSearchLable.CLEAR.toLocaleUpperCase()}
                </Button>

            </Column>
            <Column lg={6} md={6} className="text-right">
                <Button
                    className='sld-action-btn-base'
                    key="btnActivitySave"
                    onClick={() => onSaveClick()}
                    tabIndex={1026}
                    id="btnActivitySave"
                    color='primary'
                    disabled={!canUserCreateCustomerActivity}
                >{lables.SAVE.toLocaleUpperCase()}
                </Button>
            </Column>
        </Row>
    </>;

    return <div className="slider-tab-content-main-div">
        {mainContennt}
    </div>;
}


const SliderActivity = forwardRef(SliderActivityInner);
export default SliderActivity;
export { SliderActivityInner };